import React, { useState, useRef } from "react";
import { analytics, createCheckoutSession } from "./firebase/firebase";
import { useStripe } from "@stripe/react-stripe-js";

import { logEvent } from "firebase/analytics";

import TopNav from "./TopNav";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

import { MAC_DOWNLOAD } from "./utils";

import logoCircle from "./assets/logoCircle.png";
import searchImg from "./assets/searchImg.png";
import notifImg from "./assets/notifImg.png";

import { FaCheckCircle } from "react-icons/fa";

export default function HomePage() {
  const stripe = useStripe();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Handle payment form submission
  const handlePayment = async (event) => {
    event.preventDefault();

    if (!stripe) {
      // Stripe.js has not loaded yet
      return;
    }

    setLoading(true);

    try {
      const { data } = await createCheckoutSession();

      const sessionId = data.sessionId;

      // Redirect the user to the Stripe Checkout page
      const { error: stripeError } = await stripe.redirectToCheckout({
        sessionId,
      });

      if (stripeError) {
        setError(stripeError.message);
        setLoading(false);
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const downloadMac = () => {
    // console.log("Running: download mac");

    try {
      window.location.href = MAC_DOWNLOAD;

      logEvent(analytics, "button_click", {
        button_name: "download_mac",
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Create refs for the sections
  const featuresRef = useRef(null);
  const faqRef = useRef(null);

  // Scroll to the section when clicked
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <TopNav
        scrollToSection={scrollToSection}
        featuresRef={featuresRef}
        faqRef={faqRef}
      />

      <div className="flex-center mt-64">
        <h1> Block Adult Content </h1>

        {/* <button className="primaryBtn mt-24 ml-16" onClick={handlePayment}>
          Test Payment{" "}
        </button> */}

        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}

        <p className="max-width-500 mt-24">
          Block adult content effortlessly. No sign-up required, and your data
          stays private—always. Reclaim your time and focus.
        </p>
        <div className="flex">
          <button className="primaryBtn mt-24" onClick={downloadMac}>
            Download For Mac
          </button>
        </div>
      </div>

      {/* how it works section */}
      <div className="blueContainer mt-64">
        <h3> How it Works - it’s as easy as 1, 2, 3 </h3>

        <div className="flex-spaceBtwn">
          <div>
            <img
              src={logoCircle}
              className="logoCircle"
              alt="Block Forever logo"
            />

            <h4>1. Download the App</h4>
            <p>
              Download the app, grant the permissions, and start blocking to be
              protected.
            </p>
          </div>

          <div>
            <img
              src={searchImg}
              className="howitworksAsset"
              alt="Block Forever logo"
            />
            <h4>2. Automatic Blocking </h4>
            <p className="">
              If you visit a URL that is blocked, the app will automatically
              close it.
            </p>
          </div>

          <div>
            <img
              src={notifImg}
              className="howitworksAsset"
              alt="Block Forever logo"
            />
            <h4>3. Reclaim your freedom </h4>
            <p className="">
              Break free from distractions and take control of your time to live
              your best life.
            </p>
          </div>
        </div>
      </div>

      <div className="flex-center mt-64" ref={featuresRef}>
        <h2> Take Control Today </h2>

        <div className="flex-cards mt-32">
          {/* Free Card  ------------------------------------------------------- */}
          <div className="card">
            <h2> Free </h2>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8"> No sign up needed</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">Blocks the basic sites and keywords</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">Hard to bypass </span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">No browsing data stored</span>
            </div>

            <button className="primaryBtn mt-24" onClick={downloadMac}>
              Download For Mac
            </button>
          </div>

          {/* Paid Card  ------------------------------------------------------- */}

          <div className="card">
            <div className="earlyBirdTag"> Early Bird Discount </div>

            <div className="flex-spaceBtwn">
              <h2> Pro </h2>
              <span>
                <span className="caption"> One time fee: </span>
                <span className="bold priceText ml-4"> $40 </span>{" "}
                <span className="crossedText"> $100 </span>{" "}
              </span>
            </div>

            <div className="flex">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8"> No sign up needed</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">Blocks 50+ keywords and 100+ sites</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">Even harder to bypass</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">No browsing data stored</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8"> Customizable blocklist list</span>
            </div>

            <div className="flex mt-16">
              <FaCheckCircle size={16} color="#0a64bc" />
              <span className="ml-8">Coming soon: whitelists, fines, etc.</span>
            </div>

            <button className="primaryBtn mt-24" onClick={downloadMac}>
              Download For Mac
            </button>
          </div>
        </div>
      </div>

      <div className="flex-center mt-64" ref={faqRef}>
        <Faq />
      </div>

      <div className="mt-32">
        <Footer />
      </div>
    </div>
  );
}
